import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import he from './he.json';
import th from './th.json';

export type Locale = 'he' | 'th' | 'en';

const KEY = 'farmai.locale';

function saved(): Locale {
  try {
    const l = localStorage.getItem(KEY);
    if (l === 'he' || l === 'th' || l === 'en') return l;
  } catch {
    /* storage unavailable */
  }
  return 'he';
}

/** The user's language from their profile; Hebrew is right-to-left. */
export function applyLocale(locale: Locale) {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'he' ? 'rtl' : 'ltr';
  try {
    localStorage.setItem(KEY, locale);
  } catch {
    /* storage unavailable */
  }
  void i18n.changeLanguage(locale);
}

void i18n.use(initReactI18next).init({
  resources: { he: { translation: he }, en: { translation: en }, th: { translation: th } },
  lng: saved(),
  fallbackLng: { th: ['en'], default: ['he'] },
  interpolation: { escapeValue: false },
});
applyLocale(saved());

export default i18n;
